import {updateFactory} from '@modifi/redux'
import {aCreateShipment, aReFetchAllShipmentsKeyWindows} from '../../../data/shipments'
import {
  INPUT_CONTAINER_ID,
  INPUT_DOCUMENT_EXTRACTED_CONTAINER_IDS,
  INPUT_SHIPMENT_START_DATE,
} from '../components/submit-shipment/constants'
import {ShipmentPostRequestView} from '../../../lib'
import {NestedError} from '../../../utils'
import {CONTAINER_FOUND, CONTAINER_NOT_FOUND, SHIPMENT_SUBMIT} from '../../../constants/tagManager'

const {reducer, actions, selectors} = updateFactory({
  rootSelector: state => state?.pages?.shipments?.submit,
  actionNamePrefix: 'pages/shipments/submit',
  submitRequest:
    (a, data) =>
    async (dispatch): Promise<void> => {
      dispatch(a.pendingAction())

      try {
        const payload: ShipmentPostRequestView = {
          shipmentStartDate: data[INPUT_SHIPMENT_START_DATE],
        }
        if (data.documentRef) {
          // eslint-disable-next-line prefer-destructuring
          payload.documentRef = data.documentRef
        }
        if (data[INPUT_DOCUMENT_EXTRACTED_CONTAINER_IDS]?.length > 0) {
          payload.containerIds = data[INPUT_DOCUMENT_EXTRACTED_CONTAINER_IDS]
        } else {
          payload.containerIds = [data[INPUT_CONTAINER_ID]]
        }

        // send request
        await dispatch(aCreateShipment(payload))
        dispatch({
          ...a.successAction(),
          meta: {
            tracking: {
              event: SHIPMENT_SUBMIT,
              action: CONTAINER_FOUND,
              label: 'Container has been found',
            },
          },
        })
      } catch (e: any) {
        const meta = {
          tracking: {
            event: SHIPMENT_SUBMIT,
            action: CONTAINER_NOT_FOUND,
            label: 'Container could not found',
          },
        }
        if (e instanceof NestedError) {
          dispatch({
            ...a.errorAction(e.errorStack[0]),
            meta,
          })
        } else {
          dispatch({...a.errorAction(e), meta})
        }
        // need to take "reportError" api response into account before rethrowing
        // throw new NestedError('Failed to submit new shipment', e)
      } finally {
        dispatch(aReFetchAllShipmentsKeyWindows())
      }
    },
})

export default reducer

export const {
  selectUpdateHasError: selectSubmitHasError,
  selectUpdateErrorMessage: selectSubmitErrorMessage,
  selectUpdatePending: selectSubmitPending,
  selectUpdateErrorObject: selectErrorObject,
} = selectors

export const {aSubmit, aReset} = actions

// an action for triggering an event for google tag manager
export const aTriggerEvent = ({
  action,
  label,
}: {
  action: string
  label: string
}): Record<string, any> => ({
  type: 'tracking-event',
  meta: {
    tracking: {
      event: SHIPMENT_SUBMIT,
      action,
      label,
    },
  },
})
